export default process.env.AUDIOGLYPH_CONTRACT_ADDRESS ||
  '0x27198a56880B622a0EA1a7f312676Ea1702DccdD';
